<template>
  <Button
    :size="size"
    variant="link"
    v-tooltip.bottom="{
      value: getTooltipContent,
      pt: { text: 'break-normal!' },
    }"
    class="p-0"
  >
    <span class="pi pi-question-circle" :variant="variant"></span>
  </Button>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getOS } from '../../services/utilities'

const { t } = useI18n()

const props = defineProps({
  size: { type: String, default: '' },
  variant: { type: String, default: '' },
})

const userOS = getOS()

const getTooltipContent = computed(() => {
  switch (userOS) {
    case 'iOS':
    case 'Android':
      return t('messages.map.mobileTooltip')
    case 'Mac OS':
      return t('messages.map.macOSDesktopNavigation')
    default:
      return t('messages.map.defaultDesktopNavigation')
  }
})
</script>
